import { Builder } from '@builder.io/react'
import React from 'react'

import { HeadingClass, HeadingType } from 'enums'
import CustomHeading, { headingTypePropObj } from '../common/heading'

enum Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

interface Props {
  headingText: string
  headingTextColor: string
  backgroundColor: string
  textAlignment: Alignment
  headingType: HeadingType
  headingClass: HeadingClass
  showArrow: boolean
  showArrowRight?: boolean
  belowNavbar: boolean
}

const Heading = ({
  backgroundColor,
  headingTextColor,
  headingText,
  textAlignment,
  headingType,
  headingClass,
  showArrow,
  belowNavbar
}: Props) => {
  const getAlignmentClass = () => {
    if (textAlignment === Alignment.Right) {
      return 'text-right'
    }
    if (textAlignment === Alignment.Center) {
      return 'text-center'
    }
    return 'text-left'
  }

  const textAlignClass = getAlignmentClass()

  return (
    <div className={`p-4 ${textAlignClass} ${belowNavbar ? 'lg:-mt-12 lg:pt-12' : ''}`} style={{ backgroundColor }}>
      <div className="relative inline-flex w-fit">
        {showArrow && (
          <img
            className="absolute z-40 hidden lg:block"
            style={{ top: '1rem', left: '-12rem' }}
            src={'self-drawing-arrow-1.svg'}
            alt="Arrow 1"
          />
        )}
        <CustomHeading
          classList="text-center"
          headingClass={headingClass}
          headingType={headingType}
          color={headingTextColor}
        >
          {headingText}
        </CustomHeading>
      </div>
    </div>
  )
}

export default Heading

Builder.registerComponent(Heading, {
  name: 'Heading',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      ...headingTypePropObj
    },
    {
      name: 'headingClass',
      type: 'string',
      enum: ['H1', 'H2', 'H3', 'H4', 'H5', 'H6', 'altH1', 'altH2', 'altH3', 'altH4', 'altH5', 'altH6'],
      defaultValue: 'H1'
    },
    {
      name: 'headingText',
      type: 'string',
      defaultValue: 'Sample Heading'
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'center'
    },
    {
      name: 'showArrow',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'belowNavbar',
      type: 'boolean',
      defaultValue: false
    }
  ]
})
